import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    anchor: p => p.primaryLight,
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    tab: p => `rgba(${hexToRgb(p.accentWhite)}, 0.1)`,
    blockParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,

    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    anchor: p => p.primaryDark,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    tab: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.1)`,
    blockParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    anchor: p => p.primaryDark,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    tab: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.1)`,
    blockParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
